import { Platform } from 'react-native';
import Clipboard from '@react-native-clipboard/clipboard';
import { REACT_APP_BASE_URL } from '@env';

export const copyRequestLinkToClipboard = async (requestId: string): Promise<boolean> => {
  try {
    let linkUrl: string;

    if (Platform.OS === 'web') {
      // For web, create a full URL to the request detail page
      const baseUrl = window.location.origin;
      linkUrl = `${baseUrl}/request-detail?id=${requestId}`;
    } else {
      // For mobile, use the configured base URL from environment
      const baseUrl = REACT_APP_BASE_URL;
      if (!baseUrl) {
        throw new Error(
          '❌ REACT_APP_BASE_URL not configured for request link generation\n' +
          'Please set REACT_APP_BASE_URL in your .env file'
        );
      }
      linkUrl = `${baseUrl}/request-detail?id=${requestId}`;
    }

    if (Platform.OS === 'web' && navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(linkUrl);
      return true;
    } else if (Platform.OS === 'web') {
      // Fallback for older browsers or non-secure contexts
      const textArea = document.createElement('textarea');
      textArea.value = linkUrl;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const successful = document.execCommand('copy');
      document.body.removeChild(textArea);
      return successful;
    } else {
      // For mobile platforms (iOS/Android), use React Native clipboard
      Clipboard.setString(linkUrl);
      return true;
    }
  } catch (error) {
    console.error('Failed to copy link to clipboard:', error);
    return false;
  }
};